import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Phone, X, LifeBuoy } from "lucide-react";
import { CLAIM_DESK, telHref } from "@/config/claimDesk";

const DISMISS_KEY = "claim_desk_bar_dismissed";

// Slim, dismissible sticky bar shown across the public website with a
// one-tap click-to-call to the 24/7 Claim Desk. Hidden on the Claim Desk
// page itself and on the internal CRM / client / associate portals.
export default function ClaimDeskBar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(DISMISS_KEY) === "1"; } catch { return false; }
  });

  const path = location.pathname || "";
  const hidden =
    dismissed ||
    path === "/claim-desk" ||
    path === "/diwali-gift" ||
    path === "/claim-help" ||
    path.startsWith("/advisor") ||
    path.startsWith("/client") ||
    path.startsWith("/associate");

  if (hidden) return null;

  const dismiss = () => {
    setDismissed(true);
    try { localStorage.setItem(DISMISS_KEY, "1"); } catch { /* noop */ }
  };

  return (
    <div className="fixed bottom-0 inset-x-0 z-50" data-testid="claim-desk-bar">
      <div className="bg-[#1B2A4A] border-t border-[#D4A017]/40 shadow-[0_-4px_20px_rgba(0,0,0,0.25)]">
        <div className="max-w-5xl mx-auto px-3 sm:px-6 py-2.5 flex items-center gap-3">
          <LifeBuoy className="h-5 w-5 text-[#D4A017] shrink-0" />
          <button
            onClick={() => navigate("/claim-desk")}
            className="min-w-0 flex-1 text-left"
            data-testid="claim-desk-bar-link"
          >
            <p className="text-white text-sm font-semibold leading-tight truncate">
              Claim emergency? <span className="text-[#EAD08A] font-normal hidden sm:inline">Call our 24/7 Claim Desk</span>
            </p>
            <p className="text-[#EAD08A] text-xs sm:hidden">24/7 Claim Desk</p>
          </button>
          <a
            href={telHref(CLAIM_DESK.primary.phone)}
            data-testid="claim-desk-bar-call-btn"
            className="inline-flex items-center gap-1.5 h-10 px-4 rounded-xl bg-[#D4A017] hover:bg-[#c1930f] text-[#0A0F1A] font-bold text-sm active:scale-95 transition-transform shrink-0"
          >
            <Phone className="h-4 w-4" /> Call
          </a>
          <button
            onClick={dismiss}
            data-testid="claim-desk-bar-dismiss-btn"
            aria-label="Dismiss"
            className="p-1.5 rounded-lg text-white/70 hover:text-white hover:bg-white/10 shrink-0"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
